import { TMaintenanceEventType } from '@/pages/Calendar/calendar.types'
import ToolTip from '@/shared/Common/Tooltip'
import timelineConstants from '../../timeline.constants'
import css from './timelineElement.module.css'
import cn from '@/utils/cn'
import timelineElementUtils from './timelineElement.utils'
import { IMaintenanceProcessRule } from '@/pages/Processes/Maintenance/maintenance.types'

export interface ITimelineElementParams {
  tooltipText: { mainText: string; warning: string }
  date: string | null
  isToday: boolean
  isMaintenanceInterval: boolean
  isMaintenanceDay: boolean
  processRuleId: IMaintenanceProcessRule['id']
  maintenanceType: TMaintenanceEventType | null
  disabled: boolean
}

interface IProps {
  onElementClick: (processRuleId: IMaintenanceProcessRule['id']) => void
  timelineElementParams: ITimelineElementParams
  index: number
}

const TimelineElement = (props: IProps) => {
  const renderTimelineElementContent = () => {
    return (
      <>
        <span
          className={css.timelineElementContent}
          style={{
            backgroundColor: timelineElementUtils.getTimelineElementContentBackgroundColor(props.timelineElementParams),
            clipPath: `inset(${props.timelineElementParams.date && props.timelineElementParams.isToday && !props.timelineElementParams.isMaintenanceDay ? '0' : '16px'} calc(50% - 0.5px) 0 calc(50% - 0.5px))`,
          }}
        ></span>
        {props.timelineElementParams.isMaintenanceDay && (
          <span
            style={{
              backgroundColor:
                timelineConstants.timelineColors[props.timelineElementParams.maintenanceType].timelineElementPoint,
            }}
            className={css.timelineElementPoint}
          ></span>
        )}
        {props.timelineElementParams.date && (
          <span
            style={{ color: props.timelineElementParams.isToday ? 'var(--text-default)' : 'var(--text-placeholder)' }}
            className={cn(css.timelineElementDate, 'text-caption-md')}
          >
            {props.timelineElementParams.date}
          </span>
        )}
      </>
    )
  }

  const renderToolTipText = () => {
    return (
      <>
        <p className="text-nm" style={{ color: '#fff' }}>
          {props.timelineElementParams.tooltipText.mainText}
        </p>
        {props.timelineElementParams.tooltipText.warning && (
          <p className="text-nm" style={{ marginTop: '16px', color: '#fff', opacity: '0.7' }}>
            {props.timelineElementParams.tooltipText.warning}
          </p>
        )}
      </>
    )
  }

  //Весь timeline - 90 элементов
  const getTooltipPosition = () => {
    if (props.index < 11) return 'right'
    if (props.index > 79) return 'left'
    return 'bottom'
  }
  return (
    <ToolTip
      text={renderToolTipText()}
      position={getTooltipPosition()}
      delay={0.15}
      wrapperStyle={{ whiteSpace: 'pre-line' }}
    >
      <button
        disabled={props.timelineElementParams.disabled}
        onClick={() => props.onElementClick(props.timelineElementParams.processRuleId)}
        className={css.timelineElement}
        style={{
          backgroundColor: timelineElementUtils.getTimelineElementBackgroundColor(props.timelineElementParams),
          cursor: props.timelineElementParams.isMaintenanceInterval ? 'pointer' : 'initial',
        }}
        data-maintenance-type={props.timelineElementParams.maintenanceType}
      >
        {renderTimelineElementContent()}
      </button>
    </ToolTip>
  )
}

export default TimelineElement
